const CartMirrorComponent = () => {
  return (
    <div className="w-full mx-auto space-y-4 animate-pulse p-6">
      <div className="grid grid-cols-12 lg:grid-cols-6 gap-10">

        {/* Left Section - Cart + Pets */}
        <div className="col-span-12 lg:col-span-4 space-y-4">
          {/* Cart Header skeleton */}
          <div className="bg-white border-2 border-blue-200 rounded-xl shadow-2xl p-6">
            <div className="flex items-center gap-6">
              <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
              <div className="flex-1 space-y-3">
                <div className="h-6 bg-gray-200 rounded w-1/2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
              </div>
            </div>
          </div>

          {/* Pets skeleton */}
          {[1, 2].map((_, i) => (
            <div
              key={i}
              className="bg-white border-2 border-orange-200 rounded-xl shadow-md p-6 space-y-4"
            >
              {/* Pet Header */}
              <div className="h-5 bg-gray-200 rounded w-1/3"></div>

              {/* Table rows */}
              <div className="space-y-3">
                {[1, 2, 3].map(j => (
                  <div key={j} className="flex justify-between gap-4">
                    <div className="h-4 bg-gray-200 rounded w-[60%]"></div>
                    <div className="h-4 bg-gray-200 rounded w-[10%]"></div>
                    <div className="h-4 bg-gray-200 rounded w-[15%]"></div>
                    <div className="h-4 bg-gray-200 rounded w-[15%]"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="flex justify-end pt-4 mb-16">
            <div className="bg-white border-2 border-blue-200 rounded-xl shadow-2xl p-6 w-[320px]">
              <div className="flex flex-col gap-4 animate-pulse">
                {/* Row 1 - Total Discount */}
                <div className="flex justify-between items-center">
                  <div className="h-4 bg-gray-200 rounded w-[40%]"></div>
                  <div className="h-4 bg-gray-200 rounded w-[30%]"></div>
                </div>

                {/* Row 2 - Total Tax */}
                <div className="flex justify-between items-center">
                  <div className="h-4 bg-gray-200 rounded w-[35%]"></div>
                  <div className="h-4 bg-gray-200 rounded w-[25%]"></div>
                </div>

                {/* Row 3 - Net Total */}
                <div className="flex justify-between items-center">
                  <div className="h-4 bg-gray-200 rounded w-[30%]"></div>
                  <div className="h-4 bg-gray-200 rounded w-[40%]"></div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Right Section - Payment Summary */}
        <div className="col-span-12 lg:col-span-2 self-start">
          <div className="bg-white border-2 border-green-200 rounded-xl shadow-md p-6 space-y-6">
            <div className="h-6 bg-gray-200 rounded w-1/2"></div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            <div className="h-px bg-gray-200 my-4"></div>
            <div className="text-center space-y-4">
              <div className="h-6 bg-gray-200 rounded w-1/2 mx-auto"></div>
              <div className="h-8 bg-gray-200 rounded w-1/3 mx-auto"></div>
              <div className="h-10 bg-gray-200 rounded w-2/3 mx-auto"></div>
            </div>
          </div>
        </div>

      </div>
    </div>

  )
}

export default CartMirrorComponent